export default {"src":"/_next/static/media/check-mark.d612465c.svg","height":10,"width":12};